// extracted by mini-css-extract-plugin
export default {"wrapper":"Selector_wrapper__dj2F6"};